{
  "familyId": "TAA-ONT-BASIS",
  "questions": [
    {
      "id": "TAA-ONT-BASIS-001",
      "familyId": "TAA-ONT-BASIS",
      "module": "Taalbegrip",
      "tier": 2,
      "levelCode": "B6+",
      "group": 6,
      "skill": "zinsontleding",
      "subSkill": "ontl_pv_onderwerp",
      "questionType": "multiple_choice",
      "question": "Wat is het onderwerp in deze zin? 'De hond blaft luid.'",
      "context": null,
      "options": ["De hond", "blaft", "luid", "De"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [{ "type": "rule", "data": { "title": "Onderwerp vinden", "content": "Het onderwerp is wie of wat de handeling uitvoert. Stel de vraag 'Wie of wat blaft?' → De hond.", "icon": "lightbulb" }, "showWhen": "wrong" }],
      "conceptId": "identify_subject_dog",
      "variantIndex": 1,
      "citoDifficulty": 0.25,
      "citoDiscrimination": 0.82,
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": [
          { "id": "taa.ont-pv-als-onderwerp", "label": "Persoonsvorm 'blaft' aangezien voor onderwerp", "optionIndex": 1 },
          { "id": "taa.ont-bijwoord-als-onderwerp", "label": "Bijwoord 'luid' aangezien voor onderwerp", "optionIndex": 2 }
        ]
      },
      "feedback": {
        "explanationText": "Het onderwerp is wie of wat de handeling uitvoert. Zoek eerst de persoonsvorm → 'blaft'. Stel dan de vraag: 'Wie of wat blaft?' Het antwoord is 'De hond' → dat is het onderwerp.",
        "solutionSteps": ["Zoek de persoonsvorm → 'blaft'", "Stel de vraag: 'Wie of wat blaft?'", "Het antwoord is 'De hond' → dat is het onderwerp"],
        "distractorExplanations": {
          "0": "Goed! 'De hond' is het onderwerp: wie of wat blaft? → De hond.",
          "1": "Je dacht waarschijnlijk dat de persoonsvorm het onderwerp is. Maar 'blaft' is het werkwoord (de persoonsvorm), niet het onderwerp. Onthoud: het onderwerp is wie of wat de handeling uitvoert, niet de handeling zelf.",
          "2": "Je dacht waarschijnlijk dat een bijwoord het onderwerp kan zijn. Maar 'luid' geeft aan hoe de hond blaft (bijwoordelijke bepaling van wijze). Onthoud: het onderwerp is altijd een persoon, dier of ding.",
          "3": "Je dacht waarschijnlijk dat het lidwoord los staat. Maar 'De' hoort bij 'hond' — samen vormen ze het onderwerp: De hond. Onthoud: het onderwerp is de hele woordgroep, inclusief het lidwoord."
        }
      }
    },
    {
      "id": "TAA-ONT-BASIS-002",
      "familyId": "TAA-ONT-BASIS",
      "module": "Taalbegrip",
      "tier": 2,
      "levelCode": "B6+",
      "group": 6,
      "skill": "zinsontleding",
      "subSkill": "ontl_pv_onderwerp",
      "questionType": "multiple_choice",
      "question": "Wat is de persoonsvorm in deze zin? 'Ik eet een appel.'",
      "context": null,
      "options": ["eet", "Ik", "een appel", "een"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [{ "type": "rule", "data": { "title": "Persoonsvorm vinden", "content": "De persoonsvorm is het werkwoord dat verandert bij een andere persoon. Verander 'ik' naar 'hij' → hij eet. Of: 'ik eet' → 'wij eten'. Het woord dat verandert is de persoonsvorm.", "icon": "lightbulb" }, "showWhen": "wrong" }],
      "conceptId": "identify_verb_eat",
      "variantIndex": 2,
      "citoDifficulty": 0.26,
      "citoDiscrimination": 0.81,
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": [
          { "id": "taa.ont-onderwerp-als-pv", "label": "Onderwerp 'Ik' aangezien voor persoonsvorm", "optionIndex": 1 },
          { "id": "taa.ont-lv-als-pv", "label": "Lijdend voorwerp 'een appel' aangezien voor persoonsvorm", "optionIndex": 2 }
        ]
      },
      "feedback": {
        "explanationText": "De persoonsvorm is het werkwoord dat verandert bij een andere persoon. Verander 'ik' naar 'wij': 'Ik eet' → 'Wij eten'. Het woord 'eet/eten' verandert → 'eet' is de persoonsvorm.",
        "solutionSteps": ["Verander de persoon: 'Ik eet' → 'Wij eten'", "Het woord dat verandert is 'eet/eten'", "'Eet' is de persoonsvorm"],
        "distractorExplanations": {
          "0": "Goed! 'Eet' is de persoonsvorm: het werkwoord dat verandert bij een andere persoon.",
          "1": "Je dacht waarschijnlijk dat het onderwerp de persoonsvorm is. Maar 'Ik' is het onderwerp (wie eet?), niet de persoonsvorm. Onthoud: de persoonsvorm is altijd een werkwoord.",
          "2": "Je dacht waarschijnlijk dat het lijdend voorwerp de persoonsvorm is. Maar 'een appel' is het lijdend voorwerp (wat eet ik?). Onthoud: de persoonsvorm is het werkwoord dat verandert bij een andere persoon.",
          "3": "Je dacht waarschijnlijk dat een lidwoord de persoonsvorm kan zijn. Maar 'een' is een onbepaald lidwoord dat bij 'appel' hoort. Onthoud: de persoonsvorm is altijd een werkwoord."
        }
      }
    },
    {
      "id": "TAA-ONT-BASIS-003",
      "familyId": "TAA-ONT-BASIS",
      "module": "Taalbegrip",
      "tier": 2,
      "levelCode": "B6+",
      "group": 6,
      "skill": "zinsontleding",
      "subSkill": "ontl_pv_onderwerp",
      "questionType": "multiple_choice",
      "question": "Wat is het onderwerp in deze zin? 'Morgen gaat Lisa naar school.'",
      "context": null,
      "options": ["Lisa", "Morgen", "gaat", "school"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [{ "type": "rule", "data": { "title": "Onderwerp bij inversie", "content": "Bij inversie staat het onderwerp niet vooraan. Stel de vraag: 'Wie of wat gaat naar school?' → Lisa. 'Morgen' geeft aan wanneer (bijwoordelijke bepaling van tijd).", "icon": "lightbulb" }, "showWhen": "wrong" }],
      "conceptId": "subject_with_inversion",
      "variantIndex": 3,
      "citoDifficulty": 0.25,
      "citoDiscrimination": 0.79,
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": [
          { "id": "taa.ont-eerste-woord-als-onderwerp", "label": "Eerste woord 'Morgen' aangezien voor onderwerp (inversie genegeerd)", "optionIndex": 1 },
          { "id": "taa.ont-pv-als-onderwerp", "label": "Persoonsvorm 'gaat' aangezien voor onderwerp", "optionIndex": 2 }
        ]
      },
      "feedback": {
        "explanationText": "Het onderwerp staat niet altijd vooraan in de zin. Zoek de persoonsvorm → 'gaat'. Stel de vraag: 'Wie of wat gaat naar school?' Het antwoord is 'Lisa' → dat is het onderwerp. 'Morgen' staat vooraan door inversie, maar is een bijwoordelijke bepaling van tijd.",
        "solutionSteps": ["Zoek de persoonsvorm → 'gaat'", "Stel de vraag: 'Wie of wat gaat naar school?'", "Het antwoord is 'Lisa' → dat is het onderwerp", "Let op: 'Morgen' staat vooraan (inversie), maar is geen onderwerp"],
        "distractorExplanations": {
          "0": "Goed! Lisa is het onderwerp: wie of wat gaat naar school? → Lisa.",
          "1": "Je dacht waarschijnlijk dat het eerste woord altijd het onderwerp is. Maar 'Morgen' staat vooraan door inversie — het is een bijwoordelijke bepaling van tijd (wanneer?). Onthoud: gebruik altijd de wie/wat-vraag, niet de woordvolgorde.",
          "2": "Je dacht waarschijnlijk dat de persoonsvorm het onderwerp is. Maar 'gaat' is het werkwoord (de persoonsvorm). Onthoud: het onderwerp is wie of wat de handeling uitvoert.",
          "3": "Je dacht waarschijnlijk dat een zelfstandig naamwoord aan het eind het onderwerp is. Maar 'school' is onderdeel van de bepaling 'naar school' (waar?). Onthoud: stel de wie/wat-vraag bij de persoonsvorm."
        }
      }
    },
    {
      "id": "TAA-ONT-BASIS-004",
      "familyId": "TAA-ONT-BASIS",
      "module": "Taalbegrip",
      "tier": 2,
      "levelCode": "B6+",
      "group": 6,
      "skill": "zinsontleding",
      "subSkill": "ontl_pv_onderwerp",
      "questionType": "multiple_choice",
      "question": "Wat is de persoonsvorm in deze zin? 'De kinderen hebben een nieuwe bal gekocht.'",
      "context": null,
      "options": ["hebben", "kinderen", "gekocht", "bal"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [{ "type": "rule", "data": { "title": "Persoonsvorm bij samengesteld gezegde", "content": "Bij een samengesteld gezegde (twee werkwoorden) is de persoonsvorm het werkwoord dat verandert bij een andere persoon. 'De kinderen hebben' → 'Het kind heeft'. 'Hebben' verandert, dus dat is de persoonsvorm.", "icon": "lightbulb" }, "showWhen": "wrong" }],
      "conceptId": "finite_verb_compound",
      "variantIndex": 4,
      "citoDifficulty": 0.28,
      "citoDiscrimination": 0.76,
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": [
          { "id": "taa.ont-onderwerp-als-pv", "label": "Onderwerp 'kinderen' aangezien voor persoonsvorm", "optionIndex": 1 },
          { "id": "taa.ont-vd-als-pv", "label": "Voltooid deelwoord 'gekocht' aangezien voor persoonsvorm", "optionIndex": 2 }
        ]
      },
      "feedback": {
        "explanationText": "Bij twee werkwoorden in een zin verander je de persoon om te zien welk werkwoord meeverandert. 'De kinderen hebben' → 'Het kind heeft'. 'Hebben' verandert naar 'heeft' → dat is de persoonsvorm. 'Gekocht' blijft altijd 'gekocht' (voltooid deelwoord).",
        "solutionSteps": ["Zoek de werkwoorden: 'hebben' en 'gekocht'", "Verander het onderwerp: 'De kinderen hebben' → 'Het kind heeft'", "'Hebben' verandert naar 'heeft' → dat is de persoonsvorm", "'Gekocht' verandert niet → dat is het voltooid deelwoord"],
        "distractorExplanations": {
          "0": "Goed! 'Hebben' is de persoonsvorm: het verandert bij een andere persoon (hebben → heeft).",
          "1": "Je dacht waarschijnlijk dat het onderwerp de persoonsvorm is. Maar 'kinderen' is het onderwerp (wie heeft gekocht?). Onthoud: de persoonsvorm is altijd een werkwoord dat verandert bij een andere persoon.",
          "2": "Je dacht waarschijnlijk dat het voltooid deelwoord de persoonsvorm is. Maar 'gekocht' verandert niet bij een andere persoon — het blijft altijd 'gekocht'. Onthoud: de persoonsvorm is het werkwoord dat wél verandert.",
          "3": "Je dacht waarschijnlijk dat een zelfstandig naamwoord een werkwoord is. Maar 'bal' is een zelfstandig naamwoord (lijdend voorwerp). Onthoud: de persoonsvorm is altijd een werkwoord."
        }
      }
    },
    {
      "id": "TAA-ONT-BASIS-005",
      "familyId": "TAA-ONT-BASIS",
      "module": "Taalbegrip",
      "tier": 2,
      "levelCode": "B6+",
      "group": 6,
      "skill": "zinsontleding",
      "subSkill": "ontl_pv_onderwerp",
      "questionType": "multiple_choice",
      "question": "Wat is het onderwerp in deze zin? 'Op het schoolplein spelen veel kinderen.'",
      "context": null,
      "options": ["veel kinderen", "Op het schoolplein", "spelen", "het schoolplein"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [{ "type": "rule", "data": { "title": "Onderwerp achteraan", "content": "Het onderwerp staat niet altijd vooraan in de zin. Stel de vraag: 'Wie of wat spelen?' → veel kinderen. 'Op het schoolplein' geeft aan waar (bijwoordelijke bepaling van plaats).", "icon": "lightbulb" }, "showWhen": "wrong" }],
      "conceptId": "subject_end_position",
      "variantIndex": 5,
      "citoDifficulty": 0.25,
      "citoDiscrimination": 0.78,
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": [
          { "id": "taa.ont-eerste-woord-als-onderwerp", "label": "Eerste woordgroep 'Op het schoolplein' aangezien voor onderwerp", "optionIndex": 1 },
          { "id": "taa.ont-pv-als-onderwerp", "label": "Persoonsvorm 'spelen' aangezien voor onderwerp", "optionIndex": 2 },
          { "id": "taa.ont-bwb-als-onderwerp", "label": "Deel van plaatsbepaling 'het schoolplein' aangezien voor onderwerp", "optionIndex": 3 }
        ]
      },
      "feedback": {
        "explanationText": "Gebruik altijd de wie/wat-vraag, ook als het onderwerp niet vooraan staat. Zoek de persoonsvorm → 'spelen'. Stel de vraag: 'Wie of wat spelen?' Het antwoord is 'veel kinderen' → dat is het onderwerp. 'Op het schoolplein' is een bijwoordelijke bepaling van plaats (waar?).",
        "solutionSteps": ["Zoek de persoonsvorm → 'spelen'", "Stel de vraag: 'Wie of wat spelen?'", "Het antwoord is 'veel kinderen' → dat is het onderwerp", "'Op het schoolplein' is een bijwoordelijke bepaling van plaats (waar?)"],
        "distractorExplanations": {
          "0": "Goed! 'Veel kinderen' is het onderwerp: wie of wat spelen? → veel kinderen.",
          "1": "Je dacht waarschijnlijk dat de eerste woordgroep het onderwerp is. Maar 'Op het schoolplein' staat vooraan door inversie — het is een bijwoordelijke bepaling van plaats (waar?). Onthoud: gebruik altijd de wie/wat-vraag.",
          "2": "Je dacht waarschijnlijk dat de persoonsvorm het onderwerp is. Maar 'spelen' is het werkwoord (de persoonsvorm). Onthoud: het onderwerp is wie of wat de handeling uitvoert.",
          "3": "Je dacht waarschijnlijk dat een deel van de plaatsbepaling het onderwerp is. Maar 'het schoolplein' is onderdeel van 'op het schoolplein' (plaatsbepaling). Onthoud: stel de wie/wat-vraag bij de persoonsvorm."
        }
      }
    },
    {
      "id": "TAA-ONT-BASIS-006",
      "familyId": "TAA-ONT-BASIS",
      "module": "Taalbegrip",
      "tier": 2,
      "levelCode": "B6+",
      "group": 6,
      "skill": "zinsontleding",
      "subSkill": "ontl_pv_onderwerp",
      "questionType": "sentence_parser",
      "question": "Wijs het onderwerp (OND) en de persoonsvorm (PV) aan in deze zin.",
      "context": null,
      "options": [],
      "correctAnswer": 0,
      "data": {
        "sentenceParser": {
          "sentence": "De kat slaapt op de bank.",
          "words": ["De kat", "slaapt", "op de bank"],
          "labels": ["OND", "PV"],
          "colors": {
            "OND": "#3B82F6",
            "PV": "#EF4444"
          },
          "correctAssignments": {
            "0": "OND",
            "1": "PV"
          }
        }
      },
      "conceptId": "parse_subject_verb_cat",
      "variantIndex": 6,
      "citoDifficulty": 0.28,
      "citoDiscrimination": 0.78,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Onderwerp en persoonsvorm vinden",
            "content": "Zoek eerst de persoonsvorm (PV): welk werkwoord verandert bij een andere persoon? 'slaapt' → 'slapen'. Dan: wie of wat slaapt? → De kat = onderwerp (OND).",
            "icon": "lightbulb"
          }
        }
      ],
      "pedagogy": { "dok": 1 },
      "feedback": {
        "explanationText": "Zoek de persoonsvorm: 'slaapt' verandert bij een andere persoon (de katten slapen). Stel de vraag: wie of wat slaapt? → De kat. Dus: 'De kat' = onderwerp (OND), 'slaapt' = persoonsvorm (PV). 'op de bank' is een bijwoordelijke bepaling van plaats.",
        "solutionSteps": [
          "Zoek de persoonsvorm: 'slaapt' (verandert: slaapt → slapen)",
          "Stel de vraag: wie of wat slaapt?",
          "Antwoord: De kat → onderwerp (OND)",
          "'slaapt' → persoonsvorm (PV)"
        ]
      }
    },
    {
      "id": "TAA-ONT-BASIS-007",
      "familyId": "TAA-ONT-BASIS",
      "module": "Taalbegrip",
      "tier": 2,
      "levelCode": "B6+",
      "group": 6,
      "skill": "zinsontleding",
      "subSkill": "ontl_pv_onderwerp",
      "questionType": "sentence_parser",
      "question": "Wijs het onderwerp (OND) en de persoonsvorm (PV) aan. Let op: het onderwerp staat niet vooraan!",
      "context": null,
      "options": [],
      "correctAnswer": 0,
      "data": {
        "sentenceParser": {
          "sentence": "Gisteren fietste mijn broer naar school.",
          "words": ["Gisteren", "fietste", "mijn broer", "naar school"],
          "labels": ["OND", "PV"],
          "colors": {
            "OND": "#3B82F6",
            "PV": "#EF4444"
          },
          "correctAssignments": {
            "2": "OND",
            "1": "PV"
          }
        }
      },
      "conceptId": "parse_subject_verb_inversion",
      "variantIndex": 7,
      "citoDifficulty": 0.32,
      "citoDiscrimination": 0.76,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Inversie: onderwerp niet vooraan",
            "content": "Bij inversie staat het onderwerp niet vooraan. Zoek de PV: 'fietste' (verandert: fietste → fietsten). Wie of wat fietste? → mijn broer = onderwerp. 'Gisteren' is een bijwoordelijke bepaling van tijd.",
            "icon": "lightbulb"
          }
        }
      ],
      "pedagogy": { "dok": 1 },
      "feedback": {
        "explanationText": "De persoonsvorm is 'fietste' (verandert: hij fietste → zij fietsten). Wie of wat fietste? → mijn broer = onderwerp (OND). Let op: 'Gisteren' staat vooraan (inversie) maar is een bijwoordelijke bepaling van tijd, niet het onderwerp.",
        "solutionSteps": [
          "Zoek de persoonsvorm: 'fietste' (verandert: fietste → fietsten)",
          "Stel de vraag: wie of wat fietste?",
          "Antwoord: mijn broer → onderwerp (OND)",
          "'Gisteren' = bijwoordelijke bepaling van tijd (niet het onderwerp)"
        ]
      }
    },
    {
      "id": "TAA-ONT-BASIS-008",
      "familyId": "TAA-ONT-BASIS",
      "module": "Taalbegrip",
      "tier": 2,
      "levelCode": "B6+",
      "group": 6,
      "skill": "zinsontleding",
      "subSkill": "ontl_pv_onderwerp",
      "questionType": "multiple_choice",
      "question": "Wat is het onderwerp in deze zin? 'De kat slaapt op de bank.'",
      "options": ["De kat", "slaapt", "op de bank", "de bank"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "sentenceDiagram",
          "showWhen": "wrong",
          "data": {
            "sentence": "De kat slaapt op de bank.",
            "parts": [
              { "text": "De kat", "role": "onderwerp" },
              { "text": "slaapt", "role": "gezegde" },
              { "text": "op de bank", "role": "bijwoordelijke bepaling" }
            ],
            "label": "Zinsontleding"
          }
        }
      ],
      "conceptId": "identify_subject_cat",
      "variantIndex": 8,
      "citoDifficulty": 0.22,
      "citoDiscrimination": 0.84,
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": [
          { "id": "taa.ont-pv-als-onderwerp", "label": "Persoonsvorm 'slaapt' aangezien voor onderwerp", "optionIndex": 1 },
          { "id": "taa.ont-bwb-als-onderwerp", "label": "Plaatsbepaling 'op de bank' aangezien voor onderwerp", "optionIndex": 2 }
        ]
      },
      "feedback": {
        "explanationText": "Zoek eerst de persoonsvorm: 'slaapt' (verandert: slaapt → slapen). Stel dan de vraag: wie of wat slaapt? → De kat. 'Op de bank' vertelt waar de kat slaapt (bijwoordelijke bepaling van plaats).",
        "solutionSteps": [
          "Zoek de persoonsvorm → 'slaapt'",
          "Stel de vraag: wie of wat slaapt?",
          "Antwoord: 'De kat' → dat is het onderwerp"
        ],
        "distractorExplanations": {
          "0": "Goed! 'De kat' is het onderwerp: wie of wat slaapt? → De kat.",
          "1": "'Slaapt' is de persoonsvorm (het werkwoord), niet het onderwerp. Het onderwerp is wie of wat de handeling uitvoert.",
          "2": "'Op de bank' is een bijwoordelijke bepaling van plaats — het vertelt waar de kat slaapt, niet wie er slaapt.",
          "3": "'De bank' is onderdeel van de bepaling 'op de bank'. Het is niet het onderwerp, want de bank slaapt niet."
        }
      }
    },
    {
      "id": "TAA-ONT-BASIS-009",
      "familyId": "TAA-ONT-BASIS",
      "module": "Taalbegrip",
      "tier": 2,
      "levelCode": "B6+",
      "group": 6,
      "skill": "zinsontleding",
      "subSkill": "ontl_pv_onderwerp",
      "questionType": "multiple_choice",
      "question": "Wat is de persoonsvorm in deze zin? 'Morgen gaan wij naar het strand.'",
      "options": ["gaan", "Morgen", "wij", "het strand"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "sentenceDiagram",
          "showWhen": "wrong",
          "data": {
            "sentence": "Morgen gaan wij naar het strand.",
            "parts": [
              { "text": "Morgen", "role": "bijwoordelijke bepaling" },
              { "text": "gaan", "role": "gezegde" },
              { "text": "wij", "role": "onderwerp" },
              { "text": "naar het strand", "role": "bijwoordelijke bepaling" }
            ],
            "label": "Zinsontleding — inversie"
          }
        }
      ],
      "conceptId": "identify_verb_gaan_inversie",
      "variantIndex": 9,
      "citoDifficulty": 0.30,
      "citoDiscrimination": 0.78,
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "taa.ont-bijwoord-als-pv", "label": "Bijwoord 'Morgen' aangezien voor persoonsvorm", "optionIndex": 1 },
          { "id": "taa.ont-onderwerp-als-pv", "label": "Onderwerp 'wij' aangezien voor persoonsvorm", "optionIndex": 2 }
        ]
      },
      "feedback": {
        "explanationText": "De persoonsvorm is het werkwoord dat verandert bij een andere persoon. Verander 'wij' naar 'ik': 'wij gaan' → 'ik ga'. Het woord 'gaan/ga' verandert → 'gaan' is de persoonsvorm. Let op de inversie: het onderwerp 'wij' staat niet vooraan.",
        "solutionSteps": [
          "Verander de persoon: 'wij gaan' → 'ik ga'",
          "Het woord dat verandert is 'gaan/ga'",
          "'Gaan' is de persoonsvorm",
          "Let op: inversie — 'Morgen' staat vooraan, niet het onderwerp"
        ],
        "distractorExplanations": {
          "0": "Goed! 'Gaan' is de persoonsvorm: het werkwoord dat verandert bij een andere persoon (gaan → ga).",
          "1": "'Morgen' is een bijwoordelijke bepaling van tijd. Het vertelt wanneer iets gebeurt, maar is geen werkwoord.",
          "2": "'Wij' is het onderwerp (wie gaat?), niet de persoonsvorm. De persoonsvorm is altijd een werkwoord.",
          "3": "'Het strand' is onderdeel van de bepaling 'naar het strand'. Het is geen werkwoord."
        }
      }
    },
    {
      "id": "TAA-ONT-BASIS-010",
      "familyId": "TAA-ONT-BASIS",
      "module": "Taalbegrip",
      "tier": 2,
      "levelCode": "B6+",
      "group": 6,
      "skill": "zinsontleding",
      "subSkill": "ontl_pv_onderwerp",
      "questionType": "multiple_choice",
      "question": "Wat is het lijdend voorwerp in deze zin? 'Emma leest een spannend boek.'",
      "options": ["een spannend boek", "Emma", "leest", "spannend"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "sentenceDiagram",
          "showWhen": "wrong",
          "data": {
            "sentence": "Emma leest een spannend boek.",
            "parts": [
              { "text": "Emma", "role": "onderwerp" },
              { "text": "leest", "role": "gezegde" },
              { "text": "een spannend boek", "role": "lijdend voorwerp" }
            ],
            "label": "Zinsontleding"
          }
        }
      ],
      "conceptId": "identify_direct_object_book",
      "variantIndex": 10,
      "citoDifficulty": 0.35,
      "citoDiscrimination": 0.75,
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "taa.ont-onderwerp-als-lv", "label": "Onderwerp 'Emma' aangezien voor lijdend voorwerp", "optionIndex": 1 },
          { "id": "taa.ont-pv-als-lv", "label": "Persoonsvorm 'leest' aangezien voor lijdend voorwerp", "optionIndex": 2 }
        ]
      },
      "feedback": {
        "explanationText": "Het lijdend voorwerp is datgene waarop de handeling betrekking heeft. Zoek de PV: 'leest'. Wie leest? → Emma (onderwerp). Wat leest Emma? → een spannend boek (lijdend voorwerp).",
        "solutionSteps": [
          "Zoek de persoonsvorm → 'leest'",
          "Wie leest? → Emma (onderwerp)",
          "Wat leest Emma? → 'een spannend boek' (lijdend voorwerp)"
        ],
        "distractorExplanations": {
          "0": "Goed! 'Een spannend boek' is het lijdend voorwerp: wat leest Emma? → een spannend boek.",
          "1": "'Emma' is het onderwerp (wie leest?), niet het lijdend voorwerp. Het onderwerp voert de handeling uit.",
          "2": "'Leest' is de persoonsvorm (het werkwoord). Het lijdend voorwerp is het ding waarop de handeling betrekking heeft.",
          "3": "'Spannend' is een bijvoeglijk naamwoord dat bij 'boek' hoort. Het hele lijdend voorwerp is 'een spannend boek'."
        }
      }
    }
  ]
}